import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import styles from "./notification.module.css";
import { NotificationContext } from "../../createContext/Notification/NotificationContext";
import IsAuth from "../../createContext/is-Auth/IsAuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RejectIcon from "../images/rejectIcon.png";
import AcceptIcon from "../images/acceptIcon.png";
import styles2 from "./matchNotification/matchNotification.module.css";

const Backend_URL = process.env.REACT_APP_BACKEND_URL;

const RequestNotifications = () => {
  const { user, token,fetchUserInfo } = useContext(IsAuth);
  const { allNotifications } = useContext(NotificationContext);
  const [actionStates, setActionStates] = useState({});
  const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        await fetchUserInfo();
        setLoading(false);
      };
      
      fetchData();
    }, []);


  // Filter follow request notifications
  const followRequests = allNotifications.filter(
    (notification) =>
      notification.type === "followRequest" &&
      user.followRequests.some((request) => request._id === notification.creatorUser._id)
  );

  // Get unique follow requests by keeping the latest one per user
  const uniqueFollowRequests = Object.values(
    followRequests.reduce((acc, notification) => {
      const userId = notification.creatorUser._id;
      if (!acc[userId] || new Date(notification.createdAt) > new Date(acc[userId].createdAt)) {
        acc[userId] = notification;
      }
      return acc;
    }, {})
  );

  const handleFollowAction = async (requesterId, action, notificationId) => {
    // Set loading state for this specific request
    setActionStates((prev) => ({
      ...prev,
      [requesterId]: { loading: true, action },
    }));

    try {
      // Make API call to handle follow request
      const response = await axios.post(
        `${Backend_URL}/api/post/handle-follow-request`,
        {
          requesterId,
          action,
        },
        {
          headers: { token },
        }
      );

      // Update UI state to reflect the action
      setActionStates((prev) => ({
        ...prev,
        [requesterId]: { loading: false, completed: true, action },
      }));

      // Show success message
      toast.success(`Successfully ${action}ed follow request`, {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (error) {
      console.error(`Error ${action}ing follow request:`, error);

      // Reset action state on error
      setActionStates((prev) => ({
        ...prev,
        [requesterId]: { loading: false, error: true },
      }));

      // Show error message
      toast.error(`Failed to ${action} follow request. Please try again.`, {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const renderActionButtons = (notification) => {
    const requesterId = notification.creatorUser._id;
    const currentState = actionStates[requesterId] || {};

    if (currentState.completed) {
      return (
        <div className={styles.completedAction}>
          {currentState.action === "accept" ? "Accepted" : "Rejected"}
        </div>
      );
    }


    return (
      <div className={styles2.actions}>
        <>
          <button
            className={styles2.acceptButton}
            onClick={() => handleFollowAction(requesterId, "accept", notification._id)}
            disabled={currentState.loading}
            >
            <img
              src={AcceptIcon}
              alt="Accept"
              className={styles2.icon}
            />{" "}
            {currentState.loading && currentState.action === "accept"
            ? "Accepting..."
            : "Accept"}
          </button>
          <button
            className={styles2.rejectButton}
            onClick={() => handleFollowAction(requesterId, "reject", notification._id)}
            disabled={currentState.loading}// Disable if action is taken
          >
            <img
                src={RejectIcon}
                alt="Reject"
                className={styles2.icon}
            />{" "}
            {currentState.loading && currentState.action === "reject"
            ? "Rejecting..."
            : "Reject"}
          </button>
        </>
      </div>
    );
  };

  if (loading) {
    return <div className={styles.loading}>Loading...</div>;
  }    

  return (
    <div className={styles.notificationWrapper}>
      {uniqueFollowRequests.length === 0 ? (
        <div className={styles.noNotifications}>No follow requests.</div>
      ) : (
        uniqueFollowRequests.map((notification) => (
          <>
          <div key={notification._id} className={styles.notificationItem} style={{ paddingBottom: 0 }}>
            <img
              src={notification.creatorUserImage}
              alt="profile"
              className={styles.notificationImg}
            />
            <div className={styles.notificationContent}>
              <div className={styles.info}>
                <div className="flex flex-col">
                  <div className={styles.contentHighlight}>
                    {notification.creatorUser.name}
                  </div>
                  <div className={styles.userName}>
                    @{notification.creatorUser.userName}
                  </div>
                </div>
              </div>
            </div>
            {renderActionButtons(notification)}
          </div>
          <div className="flex justify-end mr-3">
          <div className={styles.time}>
          {new Date(notification.createdAt).toLocaleTimeString()}
          </div>
          </div>
          </>
        ))
      )}
      
    </div>
  );
};

export default RequestNotifications;
